import cn from 'classnames';

import { IconDownload } from '../../../icons';
import Button from '../../../components/Button/Button';
import Loader from '../../../components/Loader/Loader';
import { FileTypesStringEnum } from '../../../core/enums/FileTypesEnum';
import { AnalyticsAction } from '../../../core/models/AnalyticsAttributes';
import useNewsArticlePdfDownload from '../../../core/apiHooks/useNewsArticlePdfDownload';

import './DownloadArticlePdfButton.styles.scss';

const SPINNER_SIZE = 32;

interface iDownloadArticlePdfButtonProps {
    articleId: number;
    articleTitle?: string | null;
    className?: string;
}

const DownloadArticlePdfButton = ({ articleId, articleTitle, className }: iDownloadArticlePdfButtonProps) => {
    const { downloadPdf, isDownloading } = useNewsArticlePdfDownload(articleId, articleTitle);

    return (
        <Button
            unstyled
            className={cn('DownloadArticlePdfButton', className)}
            onClick={downloadPdf}
            isDisabled={isDownloading}
            tooltipText="Download PDF"
            analyticsData={{
                action: AnalyticsAction.NewsArticleDownload,
                reportId: articleId,
                fileType: FileTypesStringEnum.Pdf
            }}
        >
            {isDownloading ? (
                <Loader isSimple size={SPINNER_SIZE} className="DownloadArticlePdfButton__loader" />
            ) : (
                <IconDownload className="Icon32" />
            )}
        </Button>
    );
};

export default DownloadArticlePdfButton;
